<template>
  <footer class="text-right fixed-bottom pr-4 pt-4">
    <ul class="list-inline">
      <li class="list-inline-item border-right mr-2 pr-2">
        <strong>Forge</strong>
      </li>
      <li class="list-inline-item border-right mr-2 pr-2">
        <a href="https://confluence.megaport.com/display/ENG/Forge">Confluence</a>
      </li>
      <li class="list-inline-item">
        <a href="https://jira.megaport.com/secure/CreateIssue!default.jspa">Report an issue</a>
      </li>
    </ul>
  </footer>
</template>

<script>
export default {
  name: 'PageFooter',
}
</script>

<style scoped>
footer {
  background-color: var(--bg-primary) !important;
  color: var(--text-primary) !important;
  border-top: 1px solid var(--border-color) !important;
  padding-bottom: 1rem !important;
}

footer a {
  color: var(--link-color) !important;
}

footer a:hover {
  color: var(--link-color) !important;
  opacity: 0.8;
}

footer strong {
  color: var(--text-primary) !important;
}

footer .list-inline-item {
  border-right-color: var(--border-color) !important;
}
</style>
